import { useEffect, useState } from "react";
import { supabase } from '@/lib/supabase';

export const TIME_SLOTS = [
  "10:00 - 11:00",
  "11:00 - 12:00",
  "12:00 - 13:00",
  "13:00 - 14:00",
  "16:00 - 17:00",
  "17:00 - 18:00",
  "18:00 - 19:00",
] as const;

export interface SlotInfo {
  slot: string;
  available: boolean;
}

export function useAvailability(dateKey: string) {
  const [state,setState] = useState<{date:string;slots:SlotInfo[];error:string;loading:boolean}>({date:'',slots:[],error:'',loading:true});
  useEffect(() => {
    let active = true;
    let sequence = 0;
    const refresh = async () => {
      const request = ++sequence;
      try {
        if (!supabase) throw new Error('Sin conexión');
        const {data,error} = await supabase.rpc('alea_agenda_available',{day:dateKey});
        if (error || !Array.isArray(data) || data.length !== TIME_SLOTS.length ||
          TIME_SLOTS.some(slot => !data.some(row => row.slot===slot && typeof row.available==='boolean'))) throw new Error('Sin disponibilidad');
        if (active && request===sequence) setState({date:dateKey,slots:TIME_SLOTS.map(slot=>({slot,available:data.find(row=>row.slot===slot).available})),error:'',loading:false});
      } catch {
        if (active && request===sequence) setState({date:dateKey,slots:[],error:'No pudimos consultar los horarios. Revisa tu conexión; volveremos a intentarlo.',loading:false});
      }
    };
    void refresh();
    const interval=window.setInterval(()=>{if(document.visibilityState==='visible')void refresh();},5000);
    const onVisible=()=>{if(document.visibilityState==='visible')void refresh();};
    window.addEventListener('focus',onVisible);
    document.addEventListener('visibilitychange',onVisible);
    window.addEventListener('alea-agenda-changed',onVisible);
    return ()=>{active=false;window.clearInterval(interval);window.removeEventListener('focus',onVisible);document.removeEventListener('visibilitychange',onVisible);window.removeEventListener('alea-agenda-changed',onVisible);};
  },[dateKey]);
  const loading=state.date!==dateKey || state.loading;
  const slots=loading?[]:state.slots;
  return {slots,loading,error:loading?'':state.error,isFull:!loading&&!state.error&&slots.every(item=>!item.available)};
}
